/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Charterer_Representative_DescriptionInputs */



/**
* | output |
* | --- |
* | "On-site representation for charterers during operations, incidents and cargo matters." |
*
* @param {Service_Charterer_Representative_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_charterer_representative_description = /** @type {((inputs?: Service_Charterer_Representative_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Charterer_Representative_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("在作业、事故和货物事务中为租家提供现场代表服务。")
	return /** @type {LocalizedString} */ ("On-site representation for charterers during operations, incidents and cargo matters.")
});